<div class="card h-100">
    <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="card-title mb-0">{{ day | date:'EEEE, dd MMM' }}</h5>
            <button class="btn btn-link btn-sm p-0 timeline-nav-btn" (click)="navigateToDailyDetail()">
                <span class="timeline-nav-btn__circle"><i class="bi bi-chevron-right"></i></span>
            </button>
        </div>

        <h6 class="mb-2">Daily check-ins</h6>
        <div class="d-flex justify-content-between gap-2 check-ins">
            <div class="check-in" *ngFor="let name of checkinNames">
                <span
                    class="check-in__icon"
                    [class.check-in__icon--completed]="isCheckinCompleted(name)"
                    [class.check-in__icon--incomplete]="!isCheckinCompleted(name)"
                >
                    <i class="bi bi-check2" *ngIf="isCheckinCompleted(name)"></i>
                </span>
                <br>
                {{ name }}
            </div>
        </div>

        <h6 class="mt-4 mb-2">{{ behavioursLabel }}</h6>
        <div class="behaviours" [ngSwitch]="behavioursState">
            <ng-container *ngSwitchCase="'logged'">
                <div [ngClass]="behaviour.severity" *ngFor="let behaviour of behaviours">{{ behaviour.name }} [{{ behaviour.counter }}]</div>
            </ng-container>
            <div class="green" *ngSwitchCase="'none-today'">None today</div>
            <div class="grey" *ngSwitchCase="'missing'">{{ missingBehavioursLabel }}</div>
        </div>
    </div>
</div>
